import {FileType} from './FileType';

export class FileMetaData {
  fileId?: number;
  fileName?: string;
  awsS3Filename?: string;
  fileByte?: string;
  fileURL?: string;
  imageAlt?: string;
  fileTitle?: string;
  imageWidth?: number;
  imageHeight?: number;
  fileType?: FileType|null;
  version?: number;
}
